<template>
<svg viewBox="0 0 18 19" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-JiaShanZhiShi1`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.03006 14.7382L5.66383 3.78939C6.17883 2.57256 7.90163 2.5678 8.42334 3.78176L10.4449 8.48563L10.8915 7.48667C11.4197 6.30541 13.0955 6.30238 13.628 7.48172L16.8941 14.7156C17.1332 15.2451 16.7459 15.8448 16.165 15.8448H12.9233C12.8997 15.8482 12.8755 15.85 12.8506 15.85H1.76679C1.19401 15.85 0.806813 15.2656 1.03006 14.7382ZM12.9621 14.343L11.1661 10.164L11.8434 8.57917C12.017 8.17292 12.5935 8.17494 12.7643 8.58239L15.1784 14.343H12.9621ZM9.11574 9.12727L11.2055 14.343H10.209L10.2087 14.3442H3.10361L5.0752 9.06696L5.13184 9.14994C5.39264 9.53206 5.94578 9.56059 6.24451 9.20733L7.11767 8.1748L8.01151 9.19371C8.31766 9.54269 8.8638 9.49851 9.11574 9.12727ZM8.62542 7.90354L7.49362 5.07877C7.32372 4.65473 6.72099 4.66182 6.56111 5.08974L5.50349 7.92059L5.73553 8.26055L6.57899 7.26313C6.8553 6.93638 7.35752 6.93183 7.63971 7.2535L8.47217 8.20243L8.62542 7.90354Z"/></svg>
</template>
<script>

export default {
  name: 'IconJiaShanZhiShi1',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
